import CircleAlertFilledSvg from '@assets/images/svg/circle-alert-filled.svg';
import React from 'react';
import { View } from 'react-native';

export interface CircleAlertFilledIconProps {
  size?: number;
  color?: string;
}

/**
 * Filled circle-alert (Figma reservation / Remaining Balance shortfall).
 * Default color matches original SVG fill (#D8181E).
 */
export function CircleAlertFilledIcon({
  size = 14,
  color = '#D8181E',
}: Readonly<CircleAlertFilledIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircleAlertFilledSvg width={size} height={size} color={color} />
    </View>
  );
}

export default CircleAlertFilledIcon;
